<template>
  <div>
    <div class="c-topEventList" v-if="previews.length !== 0">
      <div class="c-topEventList__title">各種イベントスケジュール</div>
      <ul class="c-topEventList__cards">
        <li
          class="c-topEventList__cards__card"
          v-for="preview in previews"
          :key="preview._id"
          @click="openEventDetail(preview)"
        >
          <div class="c-topEventList__cards__card__item">
            {{ preview.title }}:
          </div>
          <div class="c-topEventList__cards__card__item">
            {{ formatInfo(preview) }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import PreviewService from "@/services/preview.service";
import PreviewReserveService from "@/services/preview-reserve.service";

export default {
  name: "event-list",
  // props: ["allow_status", "room", "name", "dispName", "to"],
  data: function() {
    return {
      previews: [],
    };
  },
  async mounted() {
    console.log("+++ EventList mounted");
    this.previews = await this.fetchPreview();
    console.log("this.previews", this.previews);

    for (let index = 0; index < this.previews.length; index++) {
      const element = this.previews[index];
      const previewID = element._id;
      console.log("previewID", previewID);

      const reservedData = await this.loadReservedPreview(previewID);
      console.log("reservedData", reservedData);

      this.$set(this.previews[index], "reservedData", reservedData);
    }
    console.log("this.previews", this.previews);
  },
  methods: {
    openEventDetail(preview) {
      console.log("openEventDetail", preview._id);
      this.$router.push({
        name: "mc-event-index",
      });
    },
    formatInfo(preview) {
      console.log("makeInfo", preview);
      if (preview.reservedData) {
        //
        let str = ``;
        const scheduleIndex = preview.reservedData.scheduleIndex;
        const komaIndex = preview.reservedData.komaIndex;
        const schedule = preview.schedules[scheduleIndex];
        const koma = schedule.komas[komaIndex];
        const date = moment(schedule.date).format("YYYY年MM月DD日");
        const is_absent = koma.is_absent;
        if (is_absent) {
          str += koma.absent_title;
        } else {
        str += `${date} ${koma.start}〜${koma.end}`;
        }

        //
        return str;
      } else {
        return "未予約";
      }
    },
    async fetchPreview() {
      const res = await PreviewService.findWithReserve("");
      return res.data;
    },
    async loadReservedPreview(previewID) {
      const res = await PreviewReserveService.findv2({
        where: {
          mansion: this.currentUser.mansion.id,
          roomNo: this.currentUser.roomNo,
          preview: previewID,
        },
      });
      console.log("res", res);
      if (res.data.length > 0) {
        // this.previewReserve = res.data[0];
        return res.data[0];
      }
    },
  },
};
</script>
<style>
.c-topEventList {
  margin-top: 3rem;
  margin-bottom: 3rem;
  background: #fff;
  padding: 1.5rem;
  display: flex;
  flex-flow: column;
  gap: 1rem;
}
.c-topEventList__title {
  font-weight: bold;
  font-size: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: solid 0.1rem #000;
}
.c-topEventList__cards {
  display: flex;
  flex-flow: column;
  row-gap: 1rem;
}
.c-topEventList__cards__card {
  cursor: pointer;
  display: flex;
}
.c-topEventList__cards__card:hover {
  opacity: 0.6;
}
.c-topEventList__cards__card__item {
  flex-basis: 50%;
  font-size: 1.2rem;
}
</style>
